<script setup>
import {onMounted, ref} from 'vue';
import HeaderDetailsPage from '@/components/layout/HeaderDetailsPage.vue';
import { useDesempenhoGeralStore } from './desempenhoGeralStore';
import InputIcon from 'primevue/inputicon';
import IconField from 'primevue/iconfield'
import { FilterMatchMode } from 'primevue/api';
import DataTable from 'primevue/datatable';
import Tag from 'primevue/tag';
import Column from 'primevue/column';
import ColumnGroup from 'primevue/columngroup';   // optional
import Row from 'primevue/row';                   // optional
import InputText from 'primevue/inputtext';
import { storeToRefs } from 'pinia';
const store = useDesempenhoGeralStore();
const { dadosCalculados, loading } = storeToRefs(store);
const tableHeight = ref('600px');
const filters = ref({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    nome: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
});

function calculateHeight() {
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;

    // Subtrai 140px para telas menores que 'md' (768px) e 70px para telas maiores
    const subtractionValue = viewportWidth < 768 ? 120 : 110;
    const desiredHeight = viewportHeight - subtractionValue;

    tableHeight.value = `${desiredHeight}px`;
}

onMounted(() => {
    calculateHeight();
})

function getSeverityFromNota(avaliacao) {

    if (avaliacao > 200) {
        return
    } else if (avaliacao > 95) {
        return "success";
    } else if (avaliacao >= 80) {
        return "info";
    } else if (avaliacao >= 60) {
        return "warning";
    } else if (avaliacao > 0)
        return "danger"

    else {
        return "neutral";
    }

}

</script>

<template>
    <HeaderDetailsPage titulo="Desempenho dos alunos" :loading="loading" />

    <DataTable sortMode="multiple" scrollable dataKey="id"
        :value="dadosCalculados" v-model:filters="filters" :globalFilterFields="['nome']" tableStyle="min-width: 50rem"
        style="margin-top: 58px;" :scrollHeight="tableHeight" size="small" stripedRows paginator :rows="5">
        <template #header>
            <div class="flex justify-content-end">
                <IconField iconPosition="left">
                    <InputIcon>
                        <i class="pi pi-search" />
                    </InputIcon>
                    <InputText v-model="filters['global'].value" placeholder="Nome do aluno" />
                </IconField>
            </div>
        </template>

        <Column field="nome" sortable header="Aluno">
            <template #body="slotProps">
                <div v-tooltip.top="slotProps.data.nome" class="estudante-column flex gap-2 align-items-center ">
                    <img :src="slotProps.data.img" :alt="slotProps.data.nome"
                        style="min-width:60px; min-height: 60px; max-width:60px; max-height: 60px; border-radius:50%; object-fit: cover;">
                    <p class="nome-estudante">{{ slotProps.data.nome }}</p>
                </div>
            </template>
        </Column>
        <Column field="media" sortable header="Desempenho">
            <template #body="slotProps">
                <Tag class="block text-center cursor-pointer w-5rem" :value="slotProps.data.media"
                    :severity="getSeverityFromNota(slotProps.data.media)" />
            </template>
        </Column>
        <Column field="totalAvaliacoes" sortable header="Número de avaliações"></Column>
        <Column field="basicos" sortable header="Total de básicos" style="min-width: 100px;"></Column>
        <Column field="disciplinasComBasico" sortable header="Total disciplinas com básico"></Column>
        <Column field="fevereiro" sortable header="Fevereiro">
            <template #body="slotProps">
                <Tag class="block text-center cursor-pointer w-5rem" :value="slotProps.data.fevereiro"
                    :severity="getSeverityFromNota(slotProps.data.fevereiro)" />
            </template>
        </Column>
        <Column field="marco" sortable header="Março">
            <template #body="slotProps">
                <Tag class="block text-center cursor-pointer w-5rem" :value="slotProps.data.marco"
                    :severity="getSeverityFromNota(slotProps.data.marco)" />
            </template>
        </Column>
        <Column field="abril" sortable header="Abril">
            <template #body="slotProps">
                <Tag class="block text-center cursor-pointer w-5rem" :value="slotProps.data.abril"
                    :severity="getSeverityFromNota(slotProps.data.abril)" />
            </template>
        </Column>
        <Column field="maio" sortable header="Maio">
            <template #body="slotProps">
                <Tag class="block text-center cursor-pointer w-5rem" :value="slotProps.data.maio"
                    :severity="getSeverityFromNota(slotProps.data.maio)" />
            </template>
        </Column>
        <Column field="junho" sortable header="Junho">
            <template #body="slotProps">
                <Tag class="block text-center cursor-pointer w-5rem" :value="slotProps.data.junho"
                    :severity="getSeverityFromNota(slotProps.data.junho)" />
            </template>
        </Column>
        <Column field="julho" sortable header="Julho">
            <template #body="slotProps">
                <Tag class="block text-center cursor-pointer w-5rem" :value="slotProps.data.julho"
                    :severity="getSeverityFromNota(slotProps.data.julho)" />
            </template>
        </Column>
        <Column field="agosto" sortable header="Agosto">
            <template #body="slotProps">
                <Tag class="block text-center cursor-pointer w-5rem" :value="slotProps.data.agosto"
                    :severity="getSeverityFromNota(slotProps.data.agosto)" />
            </template>
        </Column>
        <Column field="setembro" sortable header="Setembro">
            <template #body="slotProps">
                <Tag class="block text-center cursor-pointer w-5rem" :value="slotProps.data.setembro"
                    :severity="getSeverityFromNota(slotProps.data.setembro)" />
            </template>
        </Column>
        <Column field="outubro" sortable header="Outubro">
            <template #body="slotProps">
                <Tag class="block text-center cursor-pointer w-5rem" :value="slotProps.data.outubro"
                    :severity="getSeverityFromNota(slotProps.data.outubro)" />
            </template>
        </Column>
        <Column field="novembro" sortable header="Novembro">
            <template #body="slotProps">
                <Tag class="block text-center cursor-pointer w-5rem" :value="slotProps.data.novembro"
                    :severity="getSeverityFromNota(slotProps.data.novembro)" />
            </template>
        </Column>

    </DataTable>
</template>
<style scoped>
.estudante-column {
    max-width: 180px;
}

.texto-parecer {
    max-width: 200px;
}

.nome-estudante {
    max-width: 180px;
    white-space: normal;
    /* Permite quebra de linha */
    display: -webkit-box;
    /* Define um contêiner flexível baseado em WebKit */
    -webkit-box-orient: vertical;
    /* Define a orientação das caixas como vertical */
    -webkit-line-clamp: 3;
    /* Limita a 3 linhas */
    overflow: hidden;
    /* Esconde o excesso de texto */
    text-overflow: ellipsis;
    /* Adiciona "..." ao final do texto cortado */
}
</style>
